<template>

    <ul class="menu-nav">
        
        <template  v-for="(item, i) in currentUserMenu.menus">
        <li class="menu-section" v-bind:key="i">
            <h4 class="menu-text">{{i}}</h4>
            <i class="menu-icon flaticon-more-v2"></i>
        </li>
        
        <li
            v-for="(submenu, j) in item" :key="j"
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item menu-item-submenu"
            v-bind:class="{
                'menu-item-open': hasActiveChildren('/vue-bootstrap')
            }"
        >
            <a href="#" class="menu-link menu-toggle" >
                <i class="menu-icon flaticon2-digital-marketing"></i>
                <span class="menu-text">{{j}}</span>
                <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
                <span class="menu-arrow"></span>
                <ul v-for="(submenu2, k) in submenu" :key="k" class="menu-subnav">
                    <li aria-haspopup="true" class="menu-item menu-item-parent">
                        <span class="menu-link">
                            <span class="menu-text">{{j}}</span>
                        </span>
                    </li>
                    <router-link
                        
                        
                        :to="submenu2.link"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active'
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-bullet menu-bullet-dot">
                                    <span></span>
                                </i>
                                <span class="menu-text">{{submenu2.name}}</span>
                            </a>
                        </li>
                    </router-link>

                
                    
                
                </ul>
                
            </div>
        </li>
        
        </template>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";
//import MenuDataService from "@/core/services/store/menus.module";
export default {
    name: "KTMenu",
    data() {
        return {
             
        };
    },
    methods: {
        hasActiveChildren(match) {
            return this.$route["path"].indexOf(match) !== -1;
        },

    },

    created(){
        this.$store.dispatch( "getUserMenu");
    },

    computed: {
        ...mapGetters(["currentUserMenu"]),

    }
};
</script>
